import { atom, selector } from 'recoil'
import { IUser } from '../types/types'
import axios from 'axios'
import { getServerHost } from '../utils/get-server-host'
import { getHeaders } from '../utils/get-headers'

const userDefaultState = selector({
  key: 'userDefaultState',
  get: async () => {
    const existingToken = window.localStorage.getItem('token')

    if (!existingToken) {
      return null
    }

    try {
      const response = await axios.get(getServerHost('verify-token'), {
        headers: getHeaders(),
      })

      if (response.status === 200) {
        return response.data.user
      }
    } catch (error) {
      window.localStorage.removeItem('token')
      return null
    }
  },
})

export const loggedUserState = atom<IUser | null>({
  key: 'loggedUserState',
  default: userDefaultState,
})